class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', event => {
      event.preventDefault();
      const cartItems =
        this.closest('cart-drawer-items') ||
        this.closest('cart-items');

      const itemsToRemove = [];

      if (this.dataset.isParent) {
        // remove childs
        const childId = this.dataset.childId;
        const childItem = document.querySelector(`[data-remove-product-id="${childId}"]`);
        if (childItem) {
          itemsToRemove.push(childItem.dataset.removeProductId);
        }
      }

      // Add current item to removal list
      itemsToRemove.push(this.dataset.removeProductId);

      // Remove multiple items at once if more than one, otherwise use single remove
      if (itemsToRemove.length > 1) {
        cartItems.removeMultipleItems(itemsToRemove);
      } else {
        cartItems.updateQuantity(this.dataset.index, 0);
      }

      updateFreeShipping();
    });
  }
}
customElements.define('cart-remove-button', CartRemoveButton);

/* DELETE or CHANGE: this code is not using - start */
class ProgressBar extends HTMLElement {
  constructor() {
    super();
    this.progress = this.getAttribute('data-progress');
  }

  connectedCallback() {
    setTimeout(() => {
      this.querySelector('[data-progress-line]').style.width = this.progress;
    }, 100);
  }
}
customElements.define('progress-bar', ProgressBar);
/* DELETE or CHANGE: this code is not using - end */

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.freeShipping = document.querySelectorAll('shipping-bar');

    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]')
    ).reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);
    this.debouncedOnChange = debounce(event => {
      this.onChange(event);
    }, 300);
    this.addEventListener(
      'change', this.debouncedOnChange.bind(this)
    );

    // Initialize selling plan selectors
    this.initSellingPlanSelectors();

    updateFreeShipping();
  }

  initSellingPlanSelectors() {
    const sellingPlanSelectors = this.querySelectorAll('.selling-plan-selector');
    sellingPlanSelectors.forEach(selector => {
      selector.addEventListener('change', (event) => {
        this.onSellingPlanChange(event);
      });
    });
  }

  onSellingPlanChange(event) {
    const selector = event.target;
    const line = parseInt(selector.dataset.line);
    const quantity = parseInt(selector.dataset.quantity);
    const selectedOption = selector.options[selector.selectedIndex];
    const variantId = selector.dataset.variantId;
    
    // Check if this is a one-time purchase selection
    const isOneTime = selectedOption.hasAttribute('data-is-one-time') || selectedOption.dataset.isOneTime === 'true';

    // Clear any previous error messages
    const lineItem = document.getElementById(`CartItem-${line}`);
    if (lineItem) {
      const errorElement = lineItem.querySelector('[data-line-item-error]');
      if (errorElement) {
        errorElement.textContent = '';
        errorElement.style.display = 'none';
      }
    }

    // Disable the selector to prevent multiple rapid clicks while updating
    selector.disabled = true;

    if (isOneTime) {
      // For one-time purchase, remove the item and re-add without selling plan
      this.switchToOneTimePurchase(line, quantity);
    } else {
      // For selling plan, use the normal change method
      this.changeSellingPlan(line, quantity, selector.value);
    }
  }

  onChange(event) {
    if (event.target.name !== 'updates[]') return;

    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute('name')
    );
  }

  getSectionsToRender() {
    return [
      {
        id: `#shopify-section-${document.getElementById('main-cart-items').dataset.id}`,
        section:
          document.getElementById('main-cart-items').dataset.id,
        selector: `#shopify-section-${
          document.getElementById('main-cart-items').dataset.id
        } cart-items`
      },
      {
        id: '#cart-counter',
        section: 'cart-counter',
        selector: '#shopify-section-cart-counter'
      }
    ];
  }

  updateQuantity(line, quantity, name) {
    this.classList.add('is-loading');

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map(
        section => section.section
      ),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, {
      ...fetchConfig(),
      ...{ body }
    })
      .then(response => response.text())
      .then(state => {
        const parsedState = JSON.parse(state);
        this.getSectionsToRender().forEach(section => {
          const elementToReplace =
            section.id === '#cart-counter'
              ? document.querySelector(section.id)
              : document.querySelector(section.selector);

          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        this.updateLiveRegions(line, parsedState.item_count);
        const cartDrawerCounter = document.querySelector(
          ".cart-drawer__title-counter"
        );
        if (cartDrawerCounter) {
          cartDrawerCounter.innerHTML = parsedState.item_count;
        }
        const lineItem = document.getElementById(`CartItem-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`))
          lineItem.querySelector(`[name="${name}"]`).focus();

        // Reinitialize selling plan selectors after cart update
        this.initSellingPlanSelectors();

        updateFreeShipping();
      })
      .finally(() => this.classList.remove('is-loading'));
  }

  changeSellingPlan(line, quantity, sellingPlanId) {
    this.classList.add('is-loading');

    const data = {
      'line': line,
      'quantity': quantity,
      sections: this.getSectionsToRender().map(
        section => section.section
      ),
      sections_url: window.location.pathname
    };

    // Add selling plan ID to the data object if provided, otherwise omit it for one-time purchase
    // If sellingPlanId is explicitly null or empty, we're switching to one-time purchase
    if (sellingPlanId && sellingPlanId !== '' && sellingPlanId !== null) {
      data.selling_plan = sellingPlanId;
    }

    const body = JSON.stringify(data);

    fetch(`${routes.cart_change_url}`, {
      ...fetchConfig(),
      ...{ body }
    })
      .then(response => response.text())
      .then(state => {
        const parsedState = JSON.parse(state);
        this.getSectionsToRender().forEach(section => {
          const elementToReplace =
            section.id === '#cart-counter'
              ? document.querySelector(section.id)
              : document.querySelector(section.selector);

          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        this.updateLiveRegions(line, parsedState.item_count);
        const cartDrawerCounter = document.querySelector(
          ".cart-drawer__title-counter"
        );
        if (cartDrawerCounter) {
          cartDrawerCounter.innerHTML = parsedState.item_count;
        }

        // Reinitialize selling plan selectors after selling plan change
        this.initSellingPlanSelectors();

        updateFreeShipping();
      })
      .catch((error) => {
        console.error('Error changing selling plan:', error);
        // Show error message to user
        const lineItem = document.getElementById(`CartItem-${line}`);
        if (lineItem) {
          const errorElement = lineItem.querySelector('[data-line-item-error]');
          if (errorElement) {
            errorElement.textContent = 'Unable to change purchase option. Please try again.';
            errorElement.style.display = 'block';
          }
          // Re-enable the selector on error
          const selector = lineItem.querySelector('.selling-plan-selector');
          if (selector) {
            selector.disabled = false;
          }
        }
      })
      .finally(() => this.classList.remove('is-loading'));
  }

  switchToOneTimePurchase(line, quantity, variantId) {
    this.classList.add('is-loading');

    // Try to change the line item to the same variant but without selling plan
    const data = {
      'line': line,
      'quantity': quantity,
      sections: this.getSectionsToRender().map(
        section => section.section
      ),
      sections_url: window.location.pathname,
      selling_plan: null // Explicitly set to null to remove selling plan
    };

    const body = JSON.stringify(data);

    console.log('Switching to one-time purchase with data:', data);
    
    fetch(`${routes.cart_change_url}`, {
      ...fetchConfig(),
      ...{ body }
    })
      .then(response => {
        console.log('Response status:', response.status);
        return response.text();
      })
      .then(state => {
        console.log('Response state:', state);
        const parsedState = JSON.parse(state);
        this.getSectionsToRender().forEach(section => {
          const elementToReplace =
            section.id === '#cart-counter'
              ? document.querySelector(section.id)
              : document.querySelector(section.selector);

          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        
        this.updateLiveRegions(line, parsedState.item_count);
        const cartDrawerCounter = document.querySelector(
          ".cart-drawer__title-counter"
        );
        if (cartDrawerCounter) {
          cartDrawerCounter.innerHTML = parsedState.item_count;
        }

        // Reinitialize selling plan selectors after change
        this.initSellingPlanSelectors();
        updateFreeShipping();
      })
      .catch((error) => {
        console.error('Error switching to one-time purchase:', error);
        console.log('Trying fallback method: remove and re-add...');
        
        // Fallback: Try removing and re-adding the item without selling plan
        this.fallbackSwitchToOneTime(line, quantity, variantId);
      })
      .finally(() => this.classList.remove('is-loading'));
  }

  fallbackSwitchToOneTime(line, quantity, variantId) {
    console.log('Using fallback method to switch to one-time purchase');
    
    // Remove the current line item
    const removeData = {
      'line': line,
      'quantity': 0,
      sections: this.getSectionsToRender().map(
        section => section.section
      ),
      sections_url: window.location.pathname
    };

    fetch(`${routes.cart_change_url}`, {
      ...fetchConfig(),
      ...{ body: JSON.stringify(removeData) }
    })
    .then(response => response.text())
    .then(state => {
      console.log('Item removed, now adding back without selling plan');
      
      // Add the same variant without selling plan
      const addData = new FormData();
      addData.append('id', variantId);
      addData.append('quantity', quantity);
      
      this.getSectionsToRender().forEach(section => {
        addData.append('sections[]', section.section);
      });
      addData.append('sections_url', window.location.pathname);

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      config.body = addData;

      return fetch(`${routes.cart_add_url}`, config);
    })
    .then(response => response.text())
    .then(state => {
      console.log('Item re-added successfully');
      const parsedState = JSON.parse(state);
      this.getSectionsToRender().forEach(section => {
        const elementToReplace =
          section.id === '#cart-counter'
            ? document.querySelector(section.id)
            : document.querySelector(section.selector);

        elementToReplace.innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.section],
          section.selector
        );
      });
      
      this.updateLiveRegions(line, parsedState.item_count);
      const cartDrawerCounter = document.querySelector(
        ".cart-drawer__title-counter"
      );
      if (cartDrawerCounter) {
        cartDrawerCounter.innerHTML = parsedState.item_count;
      }

      // Reinitialize selling plan selectors after change
      this.initSellingPlanSelectors();
      updateFreeShipping();
    })
    .catch((error) => {
      console.error('Fallback method also failed:', error);
      // Show error message to user
      const lineItem = document.getElementById(`CartItem-${line}`);
      if (lineItem) {
        const errorElement = lineItem.querySelector('[data-line-item-error]');
        if (errorElement) {
          errorElement.textContent = 'Unable to switch to one-time purchase. Please try again.';
          errorElement.style.display = 'block';
        }
        // Re-enable the selector on error
        const selector = lineItem.querySelector('.selling-plan-selector');
        if (selector) {
          selector.disabled = false;
        }
      }
    })
    .finally(() => this.classList.remove('is-loading'));
  }

  updateMultipleQuantities(updates) {
    this.classList.add('is-loading');

    const body = JSON.stringify({
      updates: updates,
      sections: this.getSectionsToRender().map(
        section => section.section
      ),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_update_url}`, {
      ...fetchConfig(),
      ...{ body }
    })
      .then(response => response.text())
      .then(state => {
        const parsedState = JSON.parse(state);
        this.getSectionsToRender().forEach(section => {
          const elementToReplace =
            section.id === '#cart-counter'
              ? document.querySelector(section.id)
              : document.querySelector(section.selector);

          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });

        // Update cart counter in drawer
        const cartDrawerCounter = document.querySelector(
          ".cart-drawer__title-counter"
        );
        if (cartDrawerCounter) {
          cartDrawerCounter.innerHTML = parsedState.item_count;
        }

        // Dispatch cart refreshed event
        document.dispatchEvent(new CustomEvent("cart:refreshed", {bubbles: true}));
        this.currentItemCount = parsedState.item_count;

        // Reinitialize selling plan selectors after cart update
        this.initSellingPlanSelectors();

        updateFreeShipping();
      })
      .catch(error => {
        console.error('Error updating cart:', error);
      })
      .finally(() => this.classList.remove('is-loading'));
  }

  removeMultipleItems(lineIndexes) {
    const updates = {};
    lineIndexes.forEach(index => {
      updates[index] = 0;
    });
    this.updateMultipleQuantities(updates);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      document
        .querySelectorAll(`[data-line-item-error][data-line="${line}"]`)
        .forEach(error => {
          error.innerHTML = window.cartStrings.quantityError.replace(
            '[quantity]', document.querySelector(`[id*="ProductQuantity-${line}"]`).value
          );
        });
      }

    document.dispatchEvent(new CustomEvent("cart:refreshed", {bubbles: true}));
    this.currentItemCount = itemCount;
  }
}
customElements.define('cart-items', CartItems);

// CART DRAWER SCRIPTS
const sectionsToRender = [
  {
    id: "#cart-counter",
    section: "cart-counter",
    selector: "#shopify-section-cart-counter"
  },
  {
    id: "#CartDrawer-Body",
    section: "cart-drawer",
    selector: "#shopify-section-cart-drawer #CartDrawer-Body"
  }
];

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("keyup", event => event.code.toUpperCase() === "ESCAPE" && this.close());
    this.querySelector("#CartDrawer-Overlay").addEventListener("click", this.close.bind(this));
    this.setCartLink();
    this.parentElement.addEventListener(
      "shopify:section:select",
      () => this.open()
    );
    this.parentElement.addEventListener(
      "shopify:section:deselect",
      () => this.close()
    );
  }

  setCartLink() {
    const cartLink = document.querySelector("[data-cart-link]");
    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    cartLink.addEventListener("click", event => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener("keydown", event => {
      if (event.code.toUpperCase() !== "SPACE") return;
      event.preventDefault();
      this.open(cartLink);
    });
  }

  open(opener) {
    if (opener) this.setActiveElement(opener);
    this.classList.add("is-visible");
    this.addEventListener(
      "transitionend",
      () => {
        this.focusOnCartDrawer();
      },
      { once: true }
    );
    // bodyScroll.lock(this.querySelector('[role="dialog"]'));
    var productReccomendations = document.querySelector(
      ".product-recommendations"
    );
    if (productReccomendations) {
      if (productReccomendations.classList.contains("hidden")) {
        document
          .querySelector(".cart-drawer-items")
          .classList.add("cart-drawer-items__full");
      } else {
        document
          .querySelector(".cart-drawer-items")
          .classList.remove("cart-drawer-items__full");
      }
    }
  }

  close() {
    this.classList.remove("is-visible");
    removeTrapFocus(this.activeElement);

    const isHeaderMenuOpen = header.classList.contains("menu-open");

    if (isHeaderMenuOpen) {
      return;
    }

    // bodyScroll.unlock(this.querySelector('[role="dialog"]'));

    // if we are on the cart page, resubmit form
    if (window.location.pathname === "/cart") {
      const cartDrawerForm = document.getElementById(
        "CartDrawer-FormSummary"
      );
      if (cartDrawerForm) {
        cartDrawerForm.submit();
      }
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  focusOnCartDrawer() {
    const containerToTrapFocusOn = this.firstElementChild;
    const focusElement = this.querySelector("[data-drawer-close]");
    trapFocus(containerToTrapFocusOn, focusElement);
  }

  renderContents(response, open = true, refresh = true) {
    this.getSectionsToRender()?.forEach(section => {
      const sectionElement = document.querySelector(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(
        response.sections[section.section],
        section.selector
      );
    });
    if(refresh) {
      document.dispatchEvent(new CustomEvent("cart:refreshed", {bubbles: true}));
    }
    if (!open) {
      return;
    }
    this.open();
  }

  getSectionsToRender() {
    return sectionsToRender;
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }
}
customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return sectionsToRender;
  }
}
customElements.define("cart-drawer-items", CartDrawerItems);

// Utility function to remove multiple cart items
function removeMultipleCartItems(lineIndexes) {
  const cartItems = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
  if (cartItems) {
    cartItems.removeMultipleItems(lineIndexes);
  }
}

// Utility function to update multiple cart quantities
function updateMultipleCartQuantities(updates) {
  const cartItems = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
  if (cartItems) {
    cartItems.updateMultipleQuantities(updates);
  }
}
